<template>
  <div class="seomain">
    <st-header
      title="添加采购订单"
      :back-able="true"
    >
    </st-header>
    <div class="st-form-content">
			<st-form ref="form">
        <div class="st-form-title">基本信息</div>
        <div class="st-form-group">
          <van-cell-group inset>
            <st-form-item key="is_overseas"  label="选择采购区域" prop="is_overseas" :required="true">
              <st-select
                st-required
                st-form-prop="is_overseas"
                v-model="formData.is_overseas"
                name="采购区域"
                placeholder="请选择采购区域"
                :options="options['is_overseas']"
                :readonly="true"
								@change="overseasChange"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="isep" label="选择货源标识" prop="isep" :required="true">
              <st-select
                v-model="formData.isep"
                name="货源标识"
                placeholder="请选择货源标识"
                :options="options['isep']"
                :readonly="true"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="ponumber" v-if="itemShow('ponumber')" label="PO-NO." prop="ponumber">
              <van-field
                  class="st-form-item-input"
                  v-model="formData.ponumber"
                  name="PO-NO."
                  label=""
                  placeholder="请输入PO-NO."
                />
            </st-form-item>
						
						<st-form-item key="pinumber" v-if="itemShow('pinumber')" label="PI-NO." prop="pinumber">
						  <van-field
						      class="st-form-item-input"
						      v-model="formData.pinumber"
						      name="PI-NO."
						      label=""
						      placeholder="请输入PI-NO."
						    />
						</st-form-item>
						
						<st-form-item key="company" label="选择采购单位" prop="company" :required="true">
              <st-select
                v-model="formData.company_id"
                name="采购单位"
                placeholder="请选择采购单位"
                :options="options['company']"
              >
              </st-select>
            </st-form-item>

            <!-- <st-form-item label="选择付款账户" prop="corporation_id" :required="true">
              <st-select
                v-model="formData.corporation_id"
                name="付款账户"
                placeholder="请选择付款账户"
                :options="options['corporation']"
              >
              </st-select>
            </st-form-item> -->
						
						
						<st-form-item key="payment_corporation_type" label="选择付款账户类型" prop="payment_corporation_type" :required="true" v-if="itemShow('payment_corporation_type')">
						  <st-select
						    v-model="formData.payment_corporation_type"
						    name="付款账户类型"
						    placeholder="请选择付款账户类型"
						    :options="$option['payment_corporation_type']"
						  >
						  </st-select>
						</st-form-item>
						

            <st-form-item key="operator" label="选择采购员" prop="operator" :required="true">
              <st-select
                v-model="formData.operator"
                name="采购员"
                placeholder="请选择采购人员"
                :options="$option['getUserList']"
								:custom-params="sellerCustomParams"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="supplier_id" label="选择供应商" prop="supplier_id" :required="true">
              <st-select
                v-model="formData.supplier_id"
                name="供应商"
                placeholder="请选择供应商"
                :options="$option['getSupplier']"
								:custom-params="{status: '0'}"
              >
              </st-select>
            </st-form-item>
						
						<st-form-item key="deliverytime" label="合同交期" prop="deliverytime" :required="true">
							<st-date
								v-model="formData.deliverytime"
								name="合同交期"
								placeholder="请选择合同交期"
							></st-date>
						</st-form-item>
						
            <st-form-item key="isinvoice" label="是否需要开票" prop="isinvoice" :required="true" v-if="itemShow('isinvoice')">
              <st-select
                v-model="formData.isinvoice"
                name="是否需要开票"
                placeholder="请选择是否需要开票"
                :options="options['isinvoice']"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="tax_rate" label="税率" prop="tax_rate" :required="true" v-if="itemShow('tax_rate')">
              <st-select
                v-model="formData.tax_rate"
                name="税率"
                placeholder="请选择税率"
                :options="options['tax_rates']"
              >
              </st-select>
            </st-form-item>

           <st-form-item label="付款条件" prop="paymentterms2" :required="true" v-if="formData.is_overseas == 2">
              <st-select
                v-model="formData.paymentterms"
                name="付款条件"
                placeholder="请选择付款条件"
                :options="$option['getPayCondition2']"
								:filterable="false"
              >
              </st-select>
            </st-form-item>
						
						<st-form-item key="paymentterms1" label="付款条件" prop="paymentterms" :required="true" v-else>
						  <st-select
						    v-model="formData.paymentterms"
						    name="付款条件"
						    placeholder="请选择付款条件"
						    :options="$option['getPayCondition1']"
								:filterable="false"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item 
							key="other_paymentterms" 
							label="其他付款条件" 
							prop="other_paymentterms" 
							:required="true" 
							v-if="formData.is_overseas == '2'  && formData.paymentterms == '4'"
						>
							<van-field
								class="st-form-item-input"
								v-model="formData.other_paymentterms"
								name="其他付款条件"
								label=""
								placeholder="请输入其他付款条件"
							/>
						</st-form-item>

            <st-form-item key="payment" label="付款方式" prop="payment" :required="true">
              <st-select
                v-model="formData.payment"
                name="付款方式"
                placeholder="请选择付款方式"
                :options="options['payment']"
              >
              </st-select>
            </st-form-item>

            <st-form-item key="settlement" label="结算方式" prop="settlement" :required="true">
              <st-select
                v-model="formData.settlement"
                name="结算方式"
                placeholder="请选择结算方式"
                :options="options['settlement']"
								@change="settleChange"
              >
              </st-select>
            </st-form-item>
						
						<st-form-item key="accountperiod" label="账期" prop="accountperiod" :required="true" v-if="formData.settlement == '0'">
							<st-date
								v-model="formData.accountperiod"
								name="账期"
								placeholder="请选择账期"
							></st-date>
						</st-form-item>
						
						<st-form-item key="subsist" label="预付款(%)" prop="subsist" :required="true" v-if="formData.settlement == '1'">
							<van-field
								class="st-form-item-input"
								v-model="formData.subsist"
								name="预付款"
								label=""
								placeholder="请输入预付款(%)"
							/>
						</st-form-item>
						
						<st-form-item key="tail_type" label="尾款结算" prop="tail_type" :required="true" v-if="formData.settlement == '1'">
								<st-select
									v-model="formData.tail_type"
									name="尾款结算"
									placeholder="请选择尾款结算"
									:options="$option['getTailType']"
								>
								</st-select>
						 </st-form-item>

            <st-form-item key="currency" label="币种" prop="currency" :required="true">
              <st-select
                v-model="formData.currency"
                name="币种"
                placeholder="请选择币种"
                :options="options['currency']"
								:readonly="true"
								disabled
              >
              </st-select>
            </st-form-item>

            <st-form-item key="exchange_rate" label="汇率" prop="exchange_rate" :required="true">
              <van-field
                class="st-form-item-input"
                v-model="formData.exchange_rate"
                name="汇率"
                label=""
                placeholder="请输入汇率"
								:readonly="true"
								disabled
              />
            </st-form-item>

           <!-- <st-form-item label="采购目的" prop="intention" :required="true">
              <van-field
                class="st-form-item-input"
                v-model="formData.intention"
                name="采购目的"
                label=""
                placeholder="请填写采购目的"
                :rules="[{ required: true }]"
              />
            </st-form-item> -->
						
						<st-form-item key="intention_type" label="采购目的" prop="intention_type" :required="true">
						  <st-select
						    v-model="formData.intention_type"
						    name="采购目的"
						    placeholder="请选择采购目的"
						    :options="$option['intention_type']"
								@change="itentionTypeChange"
						  >
						  </st-select>
						</st-form-item>

						<st-form-item key="sales_order_code" label="销售单号" prop="sales_order_code" :required="true" v-if="formData.intention_type == 1" >
						  <st-select
						    v-model="formData.sales_order_code"
						    name="销售单号"
						    placeholder="请选择销售单号"
								val-field="ordercode"
						    :options="$option['getSalesOrder']"
						  >
						  </st-select>
						</st-form-item>

            <st-form-item key="customcode" label="合同编号" prop="customcode" v-if="itemShow('customcode')">
              <van-field
                class="st-form-item-input"
                v-model="formData.customcode"
                name="合同编号"
                label=""
                placeholder="请填写合同编号"
              />
            </st-form-item>
						
						<st-form-item key="ordernumber" label="第三方编号" prop="ordernumber" v-if="itemShow('ordernumber')">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.ordernumber"
						    name="第三方编号"
						    label=""
						    placeholder="请填写第三方编号"
						  />
						</st-form-item>

            <st-form-item key="remark" label="采购单备注" prop="remark" :required="formData.intention_type == 1">
              <van-field
                class="st-form-item-input"
                v-model="formData.remark"
                name="采购单备注"
                label=""
                placeholder="请填写采购单备注"
              />
            </st-form-item>
						
						<st-form-item key="deliveryplace_info.name" label="交货地点" prop="deliveryplace_info.name" :required="true">
						  <st-select
						    v-model="formData.deliveryplace_info.name"
						    name="交货地点"
						    placeholder="请选择交货地点"
						    :options="$option['deliveryplace_info_name']"
								@change="deliveryplaceChange"
						  >
						  </st-select>
						</st-form-item>
						
						<st-form-item key="deliveryplace" label="交货地址" prop="deliveryplace" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.deliveryplace"
						    name="交货地址"
						    label=""
						    placeholder="请填写交货地址"
						  />
						</st-form-item>
						
						<st-form-item key="deliveryplace_info.contacts" label="联系人" prop="deliveryplace_info.contacts" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.deliveryplace_info.contacts"
						    name="联系人"
						    label=""
						    placeholder="请填写联系人"
						  />
						</st-form-item>
						
						<st-form-item key="deliveryplace_info.contacts_tel" label="联系电话" prop="deliveryplace_info.contacts_tel" :required="true">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.deliveryplace_info.contacts_tel"
						    name="联系电话"
						    label=""
						    placeholder="请填写联系电话"
						  />
						</st-form-item>
						
						<st-form-item key="deliveryplace_info.warehouse" label="入仓号" prop="deliveryplace_info.warehouse">
						  <van-field
						    class="st-form-item-input"
						    v-model="formData.deliveryplace_info.warehouse"
						    name="入仓号"
						    label=""
						    placeholder="请填写入仓号"
						  />
						</st-form-item>

            <st-form-item key="contract_files" label="采购合同" prop="contract_files">
              <st-file-upload
                v-model="formData['contract_files']"
								name="采购合同"
              >
              </st-file-upload>
            </st-form-item>
          </van-cell-group>
        </div>
        
        <div class="st-form-title">产品信息</div>

        <div class="st-form-group">
          <van-cell-group inset>
            <div class="product-item" v-for="(v, k) in formData['items']" :key="k">
              <div class="prudcut-del-box" v-if="formData['items'].length > 1" @click="delItem(k)"><i class="el-icon-close"></i></div>
              <h3 style="text-align: center;">产品{{ k + 1 }}</h3>

              <st-form-item :key="`items.${k}.sku`" label="SKU" :prop="`items.${k}.sku`" :required="true">
                <st-select
                  v-model="formData['items'][k]['products_id']"
                  name="SKU"
                  placeholder="请选择SKU"
                  :options="options['sku']"
									@change="skuChange(k)"
                >
                </st-select>
              </st-form-item>

              <st-form-item label="产品描述" :prop="`items.${k}.products_name`">
                <van-field
                  class="st-form-item-input"
                  v-model="formData['items'][k]['products_name']"
                  name="产品描述"
                  label=""
                  placeholder="请输入产品描述"
                />
              </st-form-item>
							
							<st-form-item label="采购货物DC" :prop="`items.${k}.data_code`" :required="true">
							  <van-field
							    class="st-form-item-input"
							    v-model="formData['items'][k]['data_code']"
							    name="采购货物DC"
							    label=""
							    placeholder="请输入采购货物DC"
							  />
							</st-form-item>

              <st-form-item label="采购数量" :prop="`items.${k}.purchase_num`" :required="true">
                <van-field
                  class="st-form-item-input"
                  v-model="formData['items'][k]['purchase_num']"
                  name="采购数量"
                  label=""
                  placeholder="请输入采购总量"
                />
              </st-form-item>

              <st-form-item label="采购单价" :prop="`items.${k}.purchase_money`" :required="true">
                <van-field
                  class="st-form-item-input"
                  v-model="formData['items'][k]['purchase_money']"
                  name="采购单价"
                  label=""
                  placeholder="请输入采购单价"
                />
              </st-form-item>

              <st-form-item label="单位" :prop="`items.${k}.unit`">
                <van-field
                  class="st-form-item-input"
                  v-model="formData['items'][k]['unit']"
                  name="单位"
                  label=""
                  placeholder="请输入单位"
                />
              </st-form-item>

              <st-form-item label="备注" :prop="`items.${k}.remarks`">
                <van-field
                  class="st-form-item-input"
                  v-model="formData['items'][k]['remarks']"
                  name="备注"
                  label=""
                  placeholder="请输入备注"
                  type="textarea"
                />
              </st-form-item>
            </div>
            
          </van-cell-group>
          <div style="margin: 16px;" class="new-pruduct-btn-box">
            <button class="new-pruduct-btn" @click="newItem">
              <i class="el-icon-plus"></i>
            </button>
          </div>
        </div>

        <div style="margin: 16px;" class="form-submit-button">
          <van-button round block type="primary" :loading="loading" loading-text="提交中..." @click="onSubmit">
            提交
          </van-button>
        </div>
			</st-form>
    </div>
    
  </div>
</template>

<script>
import StFileUpload from "@/components/FileUpload.vue";
import StSelect from "@/components/Select.vue";
import StDate from "@/components/Date.vue";
import { 
  option_is_overseas, getCompanyList, getCorporation, getPurchaseUser, getSupplier, getCurrency, getPurchaseSku, getWarehouse, isep, isinvoice, tax_rates, paymentterms, payment, settlement
} from "@/views/Sto/purchase/conf/options";
import {deliveryplace as deliveryplace_conf} from "@/views/Sto/purchase/conf/conf";
import StHeader from "@/components/layout/Header.vue";
import StFormItem from "@/components/formItem.vue";
import StForm from "@/components/form.vue";

export default {
  name: 'stPurchaseAdd',
  components: {
    'st-file-upload': StFileUpload,
    'st-select': StSelect,
    "st-header": StHeader,
    "st-form-item": StFormItem,
		StForm,
		StDate,
  },
  props: {},
  data() {
    return {
      formData: {
        items: [{}],
        accountperiod: this.$formatDate(new Date(), "yyyy-MM-dd"),
				deliveryplace_info: {},
				contract_files: [],
      },
      formDataText: {},
      formRules: {},
      loading: false,
      actField: '',
      actOptions: [],
      options: {
        is_overseas: option_is_overseas,
        company: getCompanyList,
        corporation: getCorporation,
        purchaseUser: getPurchaseUser,
        supplier: getSupplier,
        currency: getCurrency,
        sku: getPurchaseSku,
        warehouse: getWarehouse,
        isep,
        isinvoice,
        tax_rates,
        paymentterms,
        payment,
        settlement,
      },
			
			sellerCustomParams: {},
			
			hideForOverseas1: false,
			hideForOverseas2: false,
			
			rates: {
				'CNY': 1,
				'USD': '',
			},
    };
  },
  watch: {},
  created() {
    this.init();
    window.h5sdk && window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "添加采购订单" });
    });
  },
  mounted() {},

  methods: {
    init() {
			this.getRates();
			this.overseasChange(1);
			this.itentionTypeChange('');
    },
		
		// 获取汇率
		getRates() {
			this.$post(this.$api.stGetRates + "USD", {}).then((res) => {
				this.rates['USD'] = res.data;
				if (this.formData.currency == 'USD') this.formData.exchange_rate = res.data;
			});
		},
		
		// 字段是否要展示
		itemShow(field) {
			let showConf = {
				'pinumber': !this.hideForOverseas1,
				'ponumber': !this.hideForOverseas1,
				'ordernumber': !this.hideForOverseas1,
				'tax_rate': !this.hideForOverseas2,
				'isinvoice': !this.hideForOverseas2,
				'payment_corporation_type': !this.hideForOverseas2,
				'customcode': !this.hideForOverseas2,
			};
			
			return showConf[field];
		},
		
		/**
		 * 采购区域更改事件
		 */
		overseasChange(val) {
			if (val == 1) {
				this.hideForOverseas1 = true;
				this.hideForOverseas2 =  false;
				this.formData.tax_rate = '13';
				this.formData.isinvoice = '0';
				this.formData.currency = 'CNY';
				this.formData.exchange_rate = this.rates['CNY'];
				this.formData.paymentterms = "";
			} else {
				this.hideForOverseas2 = true;
				this.hideForOverseas1 =  false;
				this.formData.tax_rate = '0';
				this.formData.isinvoice = '1';
				this.formData.currency = 'USD';
				this.formData.exchange_rate = this.rates['USD'];
				this.formData.paymentterms = "";
			}
		},
		
		/**
		 * 采购目的更改
		 */
		itentionTypeChange(val) {
			// 备货的时候
			if (val == 2) {
				this.$refs.form.validater.toggleErr('remark', '');
			}
			
			// 仅在“备货”场景限制采购员，避免初始化时列表被误过滤为空
			if (val == 2) {
				this.sellerCustomParams = {'ids': ['10232', '10243', '10228', '10227', '10229', '10264', '10260']};
				return;
			}
			this.sellerCustomParams = {}
		},
		
		/**
		 * 交货地点更改
		 */
		deliveryplaceChange(val) {
			let tmp = deliveryplace_conf[val];
			if (tmp) {
				this.$set(this.formData, ['deliveryplace'], tmp.deliveryplace)
				this.$set(this.formData.deliveryplace_info, ['contacts'], tmp.contacts)
				this.$set(this.formData.deliveryplace_info, ['contacts_tel'], tmp.contacts_tel)
				
			}
		},
		
		/**
		 * 结算方式更改
		 */
		settleChange() {
			// 重置数据
			this.$set(this.formData, ['subsist'], '');
			this.$set(this.formData, ['tail_type'], '0');
		},
		
    // 提交代码
    async onSubmit() {
      if (this.loading) return;
      let formValid = false;
      this.$refs.form.validater.valid((isValid, lastMsg) => {
        formValid = isValid;
        if (!isValid) {
          this.$toast.fail('表单异常：' + lastMsg);
        }
      });
      // 校验不通过
      if (!formValid) return;
      let formData = JSON.parse(JSON.stringify(this.formData));
      formData['contract_files'] = formData['contract_files'].map((item) => { return item.url; }).join(',');
      this.loading = true;
      try {
        const res = await this.$post(this.$api.stPurchaseStore, formData);
        const code = res && res.code;
        const isSuccess = code === 1 || code === '1' || code === 200 || code === '200';
        if (!isSuccess) {
          this.$toast.fail((res && res.msg) ? res.msg : '保存异常');
          return;
        }
        this.loading = false;
        this.$toast.success('创建采购单成功');
        setTimeout(() => {
          this.$router.replace('/purchase/list/0');
        }, 1000);
      } catch (err) {
        this.$toast.fail((err && err.msg) || '提交失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    // 创建一个产品
    newItem() {
      this.formData.items.push({});
    },

    // 删除一个产品
    delItem(index) {
      this.formData.items.splice(index, 1);
    },
  
		/**
		 * sku更改
		 */
		skuChange(ind) {
			this.$post(this.$api.stProductsInfo, {ids: this.formData['items'][ind]['products_id']}).then((res) => {
				let name = "";
				if (res.data) {
					if(res.data.brand){
						name = res.data.brand+'  '+res.data.name;
					}else {
						name = res.data.name
					}
				}
			
				this.$set(this.formData.items[ind], ['products_name'], name);
			});
		}
	},
};
</script>
<style lang="scss" scoped>
.st-form-content {
  margin: 20px 15px;

  .st-form-title {
    border-radius: 5px 5px 0px 0px;
    padding: 20px 21px;
    font-size: 20px;
    background-color: rgb(207, 212, 217);
  }
  .st-form-group {
    background-color: white;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
    
    .st-van-filed-label-imp {
      color: rgb(231, 91, 124);
    }

    .st-van-filed-label {
      margin: 15px 6px 8px; 
    }
    
    .van-field {
      box-shadow: inset 0 0 0 2px rgb(223,223,223);
      border-radius: 5px;
    }

    .form-submit-button {
      margin-top: 12px;
    }

    .product-item {
      background-color: rgba(230, 236, 241, 1);
      padding: 15px;
      margin-top: 18px;

      .prudcut-del-box {
        margin-top: -10px;
        float: right;
        text-align: right;
        font-size: 31px;
        color: rgba(227, 60, 100, 1);
      }
    }

    .new-pruduct-btn {
      width: 317px;
      height: 44px;
      border-radius: 5px;
      color: rgba(80, 80, 80, 1);
      background: rgba(42, 130, 228, 1);
      line-height: 150%;
      border: none;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 30px;

      .el-icon-plus {
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-weight: bolder;
      }
    }
  }
}

</style>